import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Tab } from 'semantic-ui-react';
import { EPtwStatus, IBuilding, IProject, IPtw, IUser, IWorkstation } from '@relab/alstom-ptw-shared';

import { appState } from '../../redux/selectors';
import { buildingsAction, ptwAction, ptwUpdateAction, workstationsAction } from '../../redux/actions';
import { PtwDetailInfosComponent } from './PtwDetailInfosComponent';
import { PtwDetailHistoryComponent } from './PtwDetailHistoryComponent';
import { PtwDetailCompletionComponent } from './PtwDetailCompletionComponent';
import { RootState } from '../../redux/types';
import { PtwDetailPdfExporter } from './PtwDetailPdfExporter';
import { PtwDeleteModal } from './PtwDeleteModal';
import { replace } from 'connected-react-router';
import { ptwUtils } from '../../helpers/ptwUtils';

interface PtwDetailComponentProps {
  projectId: string;
  ptwId: string;
  user: IUser;
  project: IProject;
  buildings: IBuilding[];
  workstations: IWorkstation[];
  ptw: IPtw;
  buildingsAction: typeof buildingsAction;
  workstationsAction: typeof workstationsAction;
  ptwAction: typeof ptwAction;
  ptwUpdateAction: typeof ptwUpdateAction;
  replace: typeof replace;
}

class PPtwDetailComponent extends Component<PtwDetailComponentProps> {
  componentDidMount() {
    this.props.buildingsAction();
    this.props.workstationsAction();
  }

  handlePtwUpdateRequest = () => {
    this.props.ptwAction(this.props.ptw._id);
  };

  handlePtwDelete = () => {
    if (this.props.ptw.status === EPtwStatus.NUOVO) {
      this.props.replace('./');
    }
  };

  render() {
    const { project, buildings = null, workstations = null, ptw = null, user } = this.props;

    if (!project || !buildings || !workstations || !ptw) {
      return null;
    }

    return (
      <>
        <Container fluid textAlign={'right'}>
          <PtwDetailPdfExporter
            user={user}
            project={project}
            buildings={buildings}
            workstations={workstations}
            ptw={ptw}
          />
          {ptwUtils.isDeletable(project, user, ptw) && (
            <PtwDeleteModal ptw={ptw} detailScreen onDelete={this.handlePtwDelete} />
          )}
        </Container>
        <Tab
          panes={[
            {
              menuItem: 'Details',
              render: () => (
                <Tab.Pane>
                  <PtwDetailInfosComponent
                    user={user}
                    project={project}
                    buildings={buildings}
                    workstations={workstations}
                    ptw={ptw}
                    ptwUpdateAction={this.props.ptwUpdateAction}
                    onPtwUpdateRequest={this.handlePtwUpdateRequest}
                  />
                </Tab.Pane>
              ),
            },
            {
              menuItem: 'Work Status update',
              render: () => (
                <Tab.Pane>
                  <PtwDetailCompletionComponent ptw={ptw} />
                </Tab.Pane>
              ),
            },
            {
              menuItem: 'Permit History/Flow',
              render: () => (
                <Tab.Pane>
                  <PtwDetailHistoryComponent ptw={ptw} />
                </Tab.Pane>
              ),
            },
          ]}
        />
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  user: appState(state).user,
  project: appState(state).project,
  buildings: appState(state).buildings,
  workstations: appState(state).workstations,
  ptw: appState(state).ptw,
});

export const PtwDetailComponent = connect(mapStateToProps, {
  buildingsAction,
  workstationsAction,
  ptwAction,
  ptwUpdateAction,
  replace,
})(PPtwDetailComponent);
